import { render, staticRenderFns } from "./DomainRegister.vue?vue&type=template&id=40534264&scoped=true&"
import script from "./DomainRegister.vue?vue&type=script&lang=js&"
export * from "./DomainRegister.vue?vue&type=script&lang=js&"
import style0 from "./DomainRegister.vue?vue&type=style&index=0&id=40534264&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "40534264",
  null
  
)

export default component.exports